"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.IMAGE_CARD_CHILD = exports.IMAGE_CARD_EMPTY = exports.IMAGE_CARD = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var GRADIENT = {
  backgroundImage: "linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, ".concat(_vars.COLOURS.mono.black, " 100%)"),
  borderRadius: "inherit",
  content: "\"\"",
  display: "block",
  height: "inherit",
  position: "relative",
  width: "inherit"
},
    IMAGE_CARD = function IMAGE_CARD(a, b) {
  return (0, _cxs["default"])({
    "> .image": {
      "&::after ": _objectSpread({}, GRADIENT)
    },
    position: "relative",
    borderRadius: "6px",
    width: a,
    height: b,
    margin: "0",
    cursor: "pointer"
  });
};

exports.IMAGE_CARD = IMAGE_CARD;
var IMAGE_CARD_EMPTY = (0, _cxs["default"])({
  "&::after ": _objectSpread({}, GRADIENT),
  borderRadius: "6px",
  margin: "0",
  width: "100%",
  height: "100%",
  minWidth: "100%",
  backgroundColor: _vars.COLOURS.grey.athens.bigFat
});
exports.IMAGE_CARD_EMPTY = IMAGE_CARD_EMPTY;
var IMAGE_CARD_CHILD = (0, _cxs["default"])({
  position: "absolute",
  zIndex: 10,
  left: "20px",
  bottom: "15px",
  "> .title": {
    fontSize: _vars.FONT_SIZES["default"],
    color: _vars.COLOURS.mono.white,
    letterSpacing: "1px",
    lineHeight: "20px",
    margin: "0",
    marginBottom: "2px",
    textTransform: "uppercase"
  },
  "> .sub-title": {
    fontSize: _vars.FONT_SIZES.small,
    color: _vars.COLOURS.mono.white,
    letterSpacing: "1px",
    lineHeight: "17px",
    margin: "0"
  }
});
exports.IMAGE_CARD_CHILD = IMAGE_CARD_CHILD;